function realizaProceso(dominio) {
    var parametros = {
        "dominio": dominio
    };
    $.ajax({
        data: parametros,
        url: $('#consultar_dominio').attr('action'),
        type: 'POST',
        dataType: "json",
        beforeSend: function () {
            // $("#DomSolCot").removeClass("mostrar").addClass("ocultar");
            $(".input-group-text").empty();
            $(".input-group-text").html("<i class='fas fa-spinner loading' />");
        },
        success: function (response) {
            /*	
             1: Invalid Input!
             2: Error: No results retrieved from $whoisserver server for $domain domain!
             3: Error: No appropriate Whois server found for $domain domain!
             4: Error: Dominio no disponible
             */
            if (response.id == 1) {
                $("#paso1").val("Nombre de Dominio Incorrecto");
                $(".input-group-text").empty();
                $(".input-group-text").html("<i class='fas fa-times-circle' />");
            } else if (response.id == 2) {
                $("#paso1").val("Dominio Disponible");//2
                $(".input-group-text").empty();
                $(".input-group-text").html("<i class='fas fa-check-circle' />");
                // $("#DomSolCot").removeClass("ocultar").addClass("mostrar");
            } else if (response.id == 3) {
                $("#paso1").val("Dominio Disponible");//3
                $(".input-group-text").empty();
                $(".input-group-text").html("<i class='fas fa-check-circle' />");
                // $("#DomSolCot").removeClass("ocultar").addClass("mostrar");
            } else {
                $("#paso1").val("Dominio no disponible para la venta!");
                $(".input-group-text").empty();
                $(".input-group-text").html("<i class='fas fa-times-circle' />");
                $(".resultado").slideDown("slow", function () {
                    $(this).removeClass("d-none").addClass('d-block');
                    response.msg = response.msg.replace(new RegExp("\n", "g"), "<br>");
                    $("#microCont").html("<strong>Resultado de b&uacute;squeda de informaci&oacute;n del Servidor WhoIS:</strong><br/>" + response.msg);
                    // var padre = $("#microCont").height();
                    // var alt1 = $("#DomTxt06").position().top + padre;
                    // $("#DomTxt06").css("top", (alt1) + "px");
                    // var alt2 = $("#DomOpc").position().top + padre;
                    // $("#DomOpc").css("top", (alt2) + "px");
                    // var alt3 = $("#cntDom02").position().top + padre;
                    // $("#cntDom02").css("top", (alt3) + "px");


                });
            }
        }
    });
}
// function limpiar() {
//     // $("#resultado").slideUp("slow").removeClass("d-block").addClass("d-none");
//     //     // $("#DomTxt06").css("top", (var01) + "px");
//     //     // $("#DomOpc").css("top", (var02) + "px");
//     //     // $("#cntDom02").css("top", (var03) + "px");
//     $("#microCont").empty();
//     $("#paso1").val('');
//     //     // $("#DomBtnBus").addClass("busqueda");
//     //     // $("#DomBtnBus").css("width", "80px");
//     //     // $("#DomBtnBus").html("Buscar");
// }
$(document).ready(function () {
    // var pos01 = 550;
    // var pos02 = 550;
    // var pos03 = 294;
    $("#paso1").val('');
    // $("#DomBtnBus").addClass("busqueda");
    // $("#DomBtnBus").css("width", "80px");
    // $("#DomBtnBus").html("Buscar");
    $('#limpiar').on('click', function () {
        $(".resultado").slideUp("slow").removeClass("d-block").addClass("d-none");
        $("#microCont").empty();
        $(".input-group-text").empty();
        $("#paso1").val('');
    })
    $("#consultar_dominio").submit(function (e) {
        e.preventDefault();
        // $("#DomBtnBus").removeClass("busqueda");
        // $("#DomBtnBus").css("width", "40px");
        // $("#DomBtnBus").empty();
        // if ($('.resultado').hasClass('d-block')) {
        //     $('#microCont').html('')
        //     $('.resultado').removeClass('d-block').addClass('d-none')
        // }
        // limpiar();
        realizaProceso($('#paso1').val());
    });
    // $("#DomSolCot").click(function () {
    //     window.open('cotizacion-dominio');
    // });
    // $("#DomBtnCot").click(function () {
    //     window.open('cotizacion-dominio');
    // });
    // $("#DomClean").click(function () {
    //     limpiar(pos01, pos02, pos03);
    // });

    // $("#DomOpc").accordion({ heightStyle: "content", active: false, collapsible: true, });

    // console.log($("#DomOpc").height());
    // $("#cntBigFull").css("height", "1492px");
    // $("#top-buffer-licenciamiento01").css("height", "1592px");
    // $("#slideshow-licenciamiento").css("height", "1592px");
});
$(document).keypress(function (e) { //realiza busqueda al pulsar el enter
    if (e.which == 13) {
        // $("#DomBtnBus").removeClass("busqueda");
        // $("#DomBtnBus").css("width", "40px");
        // $("#DomBtnBus").empty();
        // limpiar();
        realizaProceso($('#paso1').val());
    }
});